import React from "react";
import "./style.scss";
import * as Assets from "../../utils/svg_assets";
import ApiUtils from "../../utils/api_utils";

export const ButtonImage = ({ image, url, size }) => {
  return (
    <div className="button-img">
      <a href={url} target="_blank" rel="noreferrer">
        <img
          src={image}
          alt="img"
          style={{ width: `auto`, height: `${size}px` }}
        />
      </a>
    </div>
  );
};

export const defaultSocialMedias = (props) => {
  const { profile } = props;

  const mapingButtons = [
    {
      image: Assets.sosmedFB,
      url: profile?.facebook ? profile?.facebook : "https://www.facebook.com/",
    },
    {
      image: Assets.sosmedTW,
      url: profile?.twitter ? profile?.twitter : "https://twitter.com/",
    },
    // {
    //     image: Assets.sosmedIG,
    //     url:(profile?.instagram ? profile?.instagram : "https://www.instagram.com/")
    // },
    {
      image: Assets.sosmedLN,
      url: profile?.linkedin ? profile?.linkedin : "https://www.linkedin.com/",
    },
    {
      image: Assets.iconWeb,
      url: profile?.website ? profile?.website : "https://mail.google.com/",
    },
  ];
  return (
    <div className="btn-sosmed-group">
      <span>Contact Trough</span>
      <br />
      {mapingButtons.map((btn, index) => (
        <ButtonImage key={index} image={btn.image} url={btn.url} size={25} />
      ))}
    </div>
  );
};
